export enum BecomeSustainableActionType {
  FETCH_BECOME_SUSTAINABLE = 'FETCH_BECOME_SUSTAINABLE',
}
